import {getEnv} from '../../common/env/env';
import {PromotionBannerDto} from '../../common/shared/api/gateway/PromotionBannerDto.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {EventLog, ItemType, PromotionBannerItem} from '../generated/types';

export function createPromotionBannerItem({
  uid,
  scheme,
  title,
  left_image,
  right_image,
}: PromotionBannerDto): PromotionBannerItem {
  const eventLog: EventLog = {
    eventMeta: {
      id: scheme,
      type: 'scheme',
      provider: '서비스',
    },
    customProps: {
      banner_uid: String(uid),
      landing_path: scheme,
    },
    click: {
      copy: title,
    },
  };

  return {
    id: String(uid),
    type: ItemType.PromotionBanner,
    scheme,
    title,
    leftImage: left_image.startsWith('http')
      ? left_image
      : getKageUrl({
          kageUrlPrefix: getEnv().kageUrlPrefix,
          kageId: left_image,
          resolution: 'th3',
        }),
    rightImage: right_image
      ? right_image.startsWith('http')
        ? right_image
        : getKageUrl({
            kageUrlPrefix: getEnv().kageUrlPrefix,
            kageId: right_image,
            resolution: 'th3',
          })
      : undefined,
    eventLog,
  };
}
